import { useRef } from "react";
import { Html } from "@react-three/drei";
import audioSpotIcon from "../../static/images/audio.png";

function AudioSpot({
	audioSpot,
	selectObject,
	isPreviewComponent,
	setIsAudioSpotOpen,
	setAudioSpotDetails,
}) {
	const mesh = useRef(null);
	const onClickHandler = () => {
		if (!isPreviewComponent) {
			setIsAudioSpotOpen(true);
			setAudioSpotDetails({
				url: audioSpot.url,
				text: audioSpot.text,
			});
		} else {
			selectObject(audioSpot, mesh.current);
		}
	};
	console.log("audio:", audioSpot);
	return (
		<mesh ref={mesh} position={audioSpot.position}>
			<Html center zIndexRange={[100, 10]}>
				<img
					className="infoImagespot"
					src={audioSpotIcon}
					alt="info spot"
					width="35px"
					height="35px"
					onClick={(e) => {
						onClickHandler();
					}}
				/>
			</Html>
		</mesh>
	);
}
export default AudioSpot;
